import { EinzaGraphiQLService } from "@/services/einzaGraphiQL"

import { typeCart } from "./cart"
import { mutationAddCustomLineItems } from "./mutations/mutationAddCustomLineItems"
import { mutationAddLineItems } from "./mutations/mutationAddLineItems"
import { mutationAddScanCustomLineItems } from "./mutations/mutationAddScanCustomLineItems"
import { mutationClearPicklistEditingMode } from "./mutations/mutationClearPicklistEditingMode"
import { mutationCopyPicklistToCart } from "./mutations/mutationCopyPicklistToCart"
import { mutationCreateCustomerCart } from "./mutations/mutationCreateCustomerCart"
import { mutationDeleteAllCustomerCarts } from "./mutations/mutationDeleteAllCustomerCarts"
import { mutationDeleteCustomerCart } from "./mutations/mutationDeleteCustomerCart"
import { mutationRemoveCustomLineItems } from "./mutations/mutationRemoveCustomLineItems"
import { mutationRemoveLineItems } from "./mutations/mutationRemoveLineItems"
import { mutationResetCartShippingAddress } from "./mutations/mutationResetCartShippingAddress"
import { mutationSyncCustomerCartWithStore } from "./mutations/mutationSyncCustomerCartWithStore"
import { mutationTransferOrderAddressToCart } from "./mutations/mutationTransferOrderAddressToCart"
import { mutationTransferOrderItemsToCart } from "./mutations/mutationTransferOrderItemsToCart"
import { mutationUpdateCustomerCart } from "./mutations/mutationUpdateCustomerCart"
import { mutationUpdateCustomLineItemsConfiguration } from "./mutations/mutationUpdateCustomLineItemsConfiguration"
import { mutationUpdateLineItemsByQuantity } from "./mutations/mutationUpdateLineItemsByQuantity"
import { queryCustomerCart } from "./queries/queryCustomerCart"
import { queryCustomerCartSkus } from "./queries/queryCustomerCartSkus"
import { queryCustomerCarts } from "./queries/queryCustomerCarts"
import { queryPaginatedCustomerCart } from "./queries/queryPaginatedCart"
import { queryUserCarts } from "./queries/queryUserCarts"

const cartSchema = {
  types: [typeCart],
  resolvers: {
    Query: {
      ...queryCustomerCart,
      ...queryCustomerCarts,
      ...queryCustomerCartSkus,
      ...queryPaginatedCustomerCart,
      ...queryUserCarts,
    },
    Mutation: {
      ...mutationAddCustomLineItems,
      ...mutationAddLineItems,
      ...mutationCreateCustomerCart,
      ...mutationDeleteAllCustomerCarts,
      ...mutationDeleteCustomerCart,
      ...mutationRemoveCustomLineItems,
      ...mutationRemoveLineItems,
      ...mutationResetCartShippingAddress,
      ...mutationUpdateLineItemsByQuantity,
      ...mutationUpdateCustomerCart,
      ...mutationUpdateCustomLineItemsConfiguration,
      ...mutationTransferOrderItemsToCart,
      ...mutationTransferOrderAddressToCart,
      ...mutationSyncCustomerCartWithStore,
      ...mutationAddScanCustomLineItems,
      ...mutationCopyPicklistToCart,
      ...mutationClearPicklistEditingMode,
    },
    Cart: {
      reservationNumber: (cart) => cart?.custom?.fields?.reservationNumber || null,
      picklistNumber: (cart) => cart?.custom?.fields?.picklistNumber || null,
      paymentTill: (cart) => cart?.custom?.fields?.paymentTill || null,
      picklistOrderNumber2: async (cart) => {
        const picklistNumber = cart?.custom?.fields?.picklistNumber
        if (!picklistNumber) return null

        try {
          const graphiQLQueryObject = [
            {
              method: "findOrder",
              variables: { orderNumber: picklistNumber },
              fields: ["orderNumber2", "orderType"],
            },
          ]

          const mappedQuery = EinzaGraphiQLService.formQuery(graphiQLQueryObject)
          const orderResponse = (await EinzaGraphiQLService.getData(mappedQuery))?.data?.findOrder

          return orderResponse?.orderNumber2 || null
        } catch (e) {
          console.error("Error fetching picklistOrderNumber2:", e)
          return null
        }
      },
      picklistOrderType: async (cart) => {
        const picklistNumber = cart?.custom?.fields?.picklistNumber
        if (!picklistNumber) return null

        try {
          const graphiQLQueryObject = [
            {
              method: "findOrder",
              variables: { orderNumber: picklistNumber },
              fields: ["orderType"],
            },
          ]

          const mappedQuery = EinzaGraphiQLService.formQuery(graphiQLQueryObject)
          const orderResponse = (await EinzaGraphiQLService.getData(mappedQuery))?.data?.findOrder

          return orderResponse?.orderType || null
        } catch (e) {
          console.error("Error fetching picklistOrderType:", e)
          return null
        }
      },
      groupBillingKey: async (cart) => {
        const picklistNumber = cart?.custom?.fields?.picklistNumber
        if (!picklistNumber) return null

        try {
          const graphiQLQueryObject = [
            {
              method: "findOrder",
              variables: { orderNumber: picklistNumber },
              fields: ["groupBillingKey"],
            },
          ]

          const mappedQuery = EinzaGraphiQLService.formQuery(graphiQLQueryObject)
          const orderResponse = (await EinzaGraphiQLService.getData(mappedQuery))?.data?.findOrder

          // Simplify the groupBillingKey value to "0", "1" or null for the frontend
          // Possible values: 0 - Einzel, K - Einzel, 1 - Sammel, 2 - Sammel
          let groupBillingKey = orderResponse?.groupBillingKey || null
          if (groupBillingKey === "K") {
            groupBillingKey = 0
          }
          if (Number(groupBillingKey) > 0) {
            groupBillingKey = 1
          }

          return groupBillingKey
        } catch (e) {
          console.error("Error fetching groupBillingKey:", e)
          return null
        }
      },
    },
  },
}

export default cartSchema
